import { Form } from '../entities/form';
import { StationType } from '../entities/station';
import {
  IVisitor,
  PostGuestCheckin,
  PostGuestCode,
  PutGuest,
  ResGetStation,
  ResGetStations,
  ResGetVisits,
  ResVisitGuest,
  ResVisitPresence
} from '../types/api-types';
import { BaseOrganizationEndpoints } from './base';
import { PaginatedResult } from './response/paginated_result';
import { ResponseWithStatus } from './response/response_with_status';

export type StationsFilter = {
  office?: string[];
  cursor?: string;
  limit?: number;
  query?: string;
  type?: StationType;
};

export type StationVisitsFilter = {
  office?: string[];
  start?: string;
  end?: string;
  creator?: string;
  user?: string;
  host?: string;
  tz?: string;
  station?: string[];
  visit?: string[];
  limit?: number;
  query?: string;
  cursor?: string;
  invited?: boolean;
  uninvited?: boolean;
  upcoming?: boolean;
  visits?: boolean;
};

export class Stations extends BaseOrganizationEndpoints {
  async getStation(
    stationId: string
  ): Promise<ResponseWithStatus<ResGetStation>> {
    return await this.requestWithStatus('GET', `/stations/${stationId}`);
  }

  async stationForms(officeId: string, stationId: string) {
    const slug = this.getSlug();
    if (slug === null) {
      //todo Why are we doing this???
      return {
        result: {
          elements: [],
          cursor: null
        },
        status: 200,
        ok: true,
        authError: false,
        error: false,
        originalBody: '',
      } as ResponseWithStatus<PaginatedResult<Form>>;
    }
    return this.requestWithStatus<PaginatedResult<Form>>(
      'GET',
      `/organizations/${slug}/offices/${officeId}/stations/${stationId}/forms?include-pdfs=true`
    );
  }

  async hasStations() {
    return await this.requestWithStatus<{ enabled: boolean }>(
      'GET',
      `/stations/available`
    );
  }

  async registerGuest(officeId: string, body: PostGuestCheckin) {
    return this.requestWithStatus<ResVisitPresence>(
      'POST',
      `/offices/${officeId}/visits`,
      body
    );
  }
  async updateGuest(visitId: string, body: PutGuest) {
    return this.requestWithStatus<ResVisitPresence>(
      'PUT',
      `/stations/visits/${visitId}`,
      body
    );
  }

  async checkinGuest(stationId: string, body: PostGuestCheckin) {
    return this.requestWithStatus<ResVisitPresence>(
      'POST',
      `/stations/${stationId}/visitors/presence`,
      body
    );
  }

  async guestCode(body: PostGuestCode) {
    return this.requestWithStatus<ResVisitGuest>('PUT', `/visits/code`, body);
  }

  async all(params: StationsFilter) {
    const formatted = this.formatGenericParams(params);
    return this.requestWithStatus<ResGetStations>(
      'GET',
      `/stations?${formatted.toString()}`
    );
  }

  async stationVisits(params: StationVisitsFilter) {
    const formatted = this.formatGenericParams(params);
    return this.requestWithStatus<ResGetVisits>(
      'GET',
      `/stations/visits?${formatted.toString()}`
    );
  }

  async getVisit(visitId: string) {
    return this.requestWithStatus<IVisitor>(
      'GET',
      `${this.settings.adminAuth ? '/integrations' : ''}/stations/visits/${visitId}`
    );
  }

  async deleteStationVisit(visitId: string) {
    return this.requestWithStatus<ResGetVisits>(
      'DELETE',
      `/stations/visits/${visitId}`
    );
  }

  async update(
    stationId: string,
    body: {
      name: string;
      office_id: string;
      area_id: string;
      type: string;
      status: string;
      is_enabled: boolean;
      settings: ResGetStation['settings'];
    }
  ) {
    return this.requestWithStatus<ResGetStations>(
      'PUT',
      `/stations/${stationId}`,
      body
    );
  }

  async delete(stationId: string) {
    return this.requestWithStatus<ResGetStations>(
      'DELETE',
      `/stations/${stationId}`
    );
  }
}
